import { DELETE } from "../../APiHelper/API"

export const deleteTeam = (team_id, onSuccess, onError) => {
    DELETE(`/api/v1/leagues/team/${team_id}`, onSuccess, onError)
}